<template>
  <div class="ccck_home">
    <div v-if="!pupopShow" >
      <div class="title">
        <div class="title_left">出口核查</div>
      </div>
      <div class="content">
        <div class="table_content">
          <div class="bodyHeader">
            <el-form
                ref="search"
                :model="searchForm"
                label-width="85px"
                style="
              height: 64px;
              width: calc(100% - 190px);
              margin: 0 auto;
              display: flex;
              margin-top: 15px;
            "
            >
              <el-form-item label="申请表号" prop="appno" class="item">
                <el-input
                    v-model="searchForm.appno"
                    placeholder="请输入"
                    clearable
                />
              </el-form-item>
              <el-form-item label="化学品名称" prop="cdCNa" class="item">
                <el-input
                    v-model="searchForm.cdCNa"
                    placeholder="请输入"
                    clearable
                />
              </el-form-item>
              <el-form-item label="核查函号" prop="gjCkhh" class="item">
                <el-input
                    v-model="searchForm.gjCkhh"
                    placeholder="请输入"
                    clearable
                />
              </el-form-item>
              <el-form-item label="出口商" prop="gjCkhh" class="item">
                <el-input
                    v-model="searchForm.exporterNameCn"
                    placeholder="请输入"
                    clearable
                />
              </el-form-item>
              <el-form-item label="进口国" prop="gjCkhh" class="item">
                <el-input
                    v-model="searchForm.cnyCNa"
                    placeholder="请输入"
                    clearable
                />
              </el-form-item>
              <el-form-item label="核查状态" prop="status">
                <el-select
                    v-model="searchForm.status"
                    clearable
                    style="max-width: 150px"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="(item, i) in statusData"
                      :key="i"
                      :label="item"
                      :value="i"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <div
                style="
              width: 190px;
              display: flex;
              padding-top: 15px;
              margin-left: 10px;
            "
            >
              <el-button
                  type="primary"
                  style="
                width: 90px;
                height: 39px;
                border-color: #409eff;
                border-radius: 3px;
              "
                  icon="el-icon-search"
                  @click="searchHandle"
              >搜索</el-button>
              <el-button
                  icon="el-icon-refresh-left"
                  style="
                width: 90px;
                height: 39px;
                border-color: #409eff;
                color: #409eff;
                border-radius: 3px;
              "
                  @click="reset"
              >重置</el-button>
            </div>
          </div>
          <div style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;">
            <div class="tablemes">
              <el-table
                  :loading="loading"
                  :data="tableData"
                  border
                  :show-overflow-tooltip="true"
                  :header-cell-style="{ background: '#F2F2F2' }"
                  style="width: 100%"
              >
                <el-table-column>
                  <template slot="header">
                    <el-button
                        v-preventReClick
                        type="primary"
                        class="addButton"
                        style="border: none"
                        size="mini"
                        @click="exportList"
                    >导出</el-button>
                  </template>
                  <el-table-column
                      prop="appno"
                      label="申请表号"
                      min-width="100px"
                      align="center"
                      show-overflow-tooltip
                  />
                  <el-table-column
                      prop="gjCkhh"
                      label="出口函号"
                      min-width="100px"
                      align="center"
                      show-overflow-tooltip
                  />
                  <el-table-column
                      prop="cdCNa"
                      label="化学品名称"
                      align="center"
                      show-overflow-tooltip
                      min-width="130px"
                  />
                  <el-table-column
                      prop="hxpsl"
                      label="数量"
                      align="center"
                      show-overflow-tooltip
                  />
                  <el-table-column
                      prop="exporterNameCn"
                      label="出口商"
                      min-width="100px"
                      align="center"
                      show-overflow-tooltip
                  />
                  <el-table-column
                      prop="cnyCNa"
                      label="进口国"
                      align="center"
                      show-overflow-tooltip
                  />
                  <el-table-column
                      prop="cusCna"
                      label="报关口岸"
                      align="center"
                      show-overflow-tooltip
                  />
                  <el-table-column prop="cjsj" label="创建时间" width="100" align="center" />
                  <el-table-column prop="gaDte" label="核查时间"  width="100" align="center" />
                  <el-table-column label="核查状态" align="center">
                    <template slot-scope="scoped">
                <span
                    :style="{
                    color: colors[scoped.row.status] || 'rgb(123,123,123)',
                  }"
                    class="inlineTableText"
                >{{ scoped.row.statusLabel }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="100px">
                    <template slot-scope="scope">
                      <el-button
                          type="primary"
                          size="mini"
                          round
                          @click="showDetail(scope.row.id)"
                      >查看</el-button>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
              <el-pagination
                  background
                  layout="prev,pager,next,jumper,total,sizes"
                  :total="total"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pageSize"
                  :current-page.sync="currentPage"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <CkhcDetail ref="ckhcDetail" :dataId="dataId" v-if="pupopShow"/>
  </div>
</template>
<script>
import CkhcDetail from "@/components/ckhc/ckhcDetail.vue";
import {kfckhcExport, kfckhcList} from "@/assets/js/system";
import {returnShowPic} from "@/assets/js/common";
export default {
  name: 'ckhcgl',
  components: {CkhcDetail},
  props: {},
  data() {
    return {
      mountedFlag: false, // true代表执行了mounted
      pupopShow: false,
      loading: false,
      pageSize: 10,
      currentPage: 1,
      total: 4,
      dataId:"",
      // 18 待核查 19核查中 20已反馈 22核查通过，24核查不通过
      colors: {
        '18': 'rgb(123,123,123)',
        '19': 'orange',
        '20': 'rgb(120,170,234)',
        '22': '#27c60d',
        '24': 'red',
        '25': '#409EFF'
      },
      statusData: {
        '18': '待核查',
        '19': '核查中',
        '20': '已反馈',
        '22': '核查通过',
        '24': '核查不通过',
        '25': '已退回'
      },
      gjHhjgData: {
        '01': '回函反对',
        '02': '回函同意',
        '03': '已读超时',
        '04': '未读超时'
      },
      // 01 回函反对, 02 回函同意 ,03 已读超时,04 未读超时
      searchForm: {
        cdCNa: '',
        appno: '',
        status: '',
        gjCkhh: '',
        exporterNameCn:'',
        cnyCNa:''
      },
      tableData: []
    }
  },
  computed: {},
  watch: {},
  created() { },
  activated() {
    if (!this.mountedFlag) { // 若没执行mounted，则执行这个；（Tab页非新打开的，是不会执行mounted的）
      this.loadData()
    }
    this.mountedFlag = false
  },
  mounted() {
    this.mountedFlag = true
    this.loadData()
  },
  beforeDestroy() { },
  methods: {
    exportList() {
      this.$message.info("正在导出中...")
      kfckhcExport({
        page: this.currentPage,
        size: this.pageSize,
        param: this.searchForm
      })
          .then((res) => {
            if (res.status == 200) {
              this.$message.success('导出成功!')
              const table = '出口核查'
              const a = document.createElement('a')
              const blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
              })
              const objectUrl = URL.createObjectURL(blob)
              a.setAttribute('href', objectUrl)
              a.setAttribute('download', table + '.xlsx')
              a.click()
            }
          })
          .catch((err) => {
            return
          })
    },
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.currentPage = 1
      this.pageSize = 10
      this.loadData()
    },
    searchHandle() {
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      kfckhcList({
        page: this.currentPage,
        size: this.pageSize,
        param: this.searchForm
      }).then(res => {
        this.loading = false
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    handleNodeClick(data) {
      console.log(data)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.loadData()
    },
    showDetail(dataId) {
      this.dataId = dataId
      this.pupopShow = true
    }
  }
}
</script>
<style scoped lang="less">
.ccck_home {
  //@y
  height: 100%;
  padding: 15px;
  background-color: #eef1f9;
  display: flex;
  flex-direction: column;
  .title {
    background-color: white;
    width: 100%;
    height: 50px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title_left {
      padding-left: 5px;
      border-left: #2674e0 3px solid;
      color: #2674e0;
      font-weight: 700;
    }
    .title_right {
      display: flex;
      align-items: center;
      margin-right: 30px;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .content {
    height: calc(100% - 65px);
    display: flex;
    justify-content: space-between;
    .table_content {
      height: 100%;
      width: 100%;
      background-color: white;
      padding: 25px 25px 0 25px;
      .bodyHeader {
        display: flex;
        width: 100%;
        margin: 0 auto;
      }
      .tablemes {
        //margin-top: 25px;
      }
    }
  }
}
/deep/.el-table {
  thead {
    font-weight: 500;
    background: #f3f5fa !important;
    color: #505050;
    font-size: 14px;
    & th {
      background-color: transparent;
    }
    & tr {
      background-color: transparent;
    }
  }
}
/*修改滚动条样式*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
::-webkit-scrollbar-thumb {
  background: #868181;
  border-radius: 10px;
}
.shenpi {
  width: 60px;
  height: 27px;
  border-radius: 20px;
  // color: #3a8fea;
}
</style>
